module.exports = __webpack_public_path__ + "img/Led_Indicator.3d58857c.jpg";